import styled, { css } from 'styled-components';

import { zIndex, color, media } from 'app/shared/styles_js/variables';
import { SignupFormSt } from 'app/shared/components/NewsletterSignupForm/NewsletterSignupForm.css';

export const ModalSt = styled.div`
  position: fixed;
  z-index: ${zIndex.slideIn};
  bottom: 21px;
  left: calc((100% - 712px) / 2 - 16px);
  overflow: hidden;
  width: 520px;
  height: 346px;
  background: rgb(245, 245, 245);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  transform: ${({ mode }) => {
    switch (mode) {
      case 'bounce':
        return 'translateY(-100px)';
      case 'slide':
        return 'translateY(0)';
      default:
        return 'translateY(470px)';
    }
  }};
  transition: transform 0.8s ease-in-out;
  
  ${media.lg(
    css`
      left: calc((100% - 952px) / 2 - 16px);
    `,
  )}
  ${media.xl(
    css`
      left: calc((100% - 1173px) / 2 - 16px);
    `,
  )}
  
  ${SignupFormSt} {
    padding: 0;
  }
`;

export const LegalCopySt = styled.div`
  display: block;
  padding: 0 16px 16px;
  text-align: left;
  line-height: 1.33;
  color: ${color.grayDarker};
  font-size: 10px;

  a {
    color: ${color.grayDarker};
  }
`;

export const IconCloseSt = styled.i`
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
`;
